import { type UseQueryResult, useQuery } from 'react-query';
import { SortOrderTypeService } from '@wealthlane/api-services/wealthlane-report-service';

const useGetReportSorting = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const reportSortingList = useQuery(
    ['getReportSorting'],
    async () => {
      return await handleRequest(
        SortOrderTypeService.getApiReportApiAppSortOrderTypeSortOrderType()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return reportSortingList;
};

export default useGetReportSorting;
